export default "__VITE_ASSET__CCay8jEm__"